import StickyHeader from "../components/StickyHeader";
function getAnchorFromLink(link) {
    return link.getAttribute("data-target") || link.getAttribute("href");
}
/**
 * Get target element from link URL or target ID.
 */
function getTargetFromHashLink(link) {
    const anchor = getAnchorFromLink(link);
    const el = document.getElementById(anchor.split("#")[1]);
    return el ? el : null;
}
export default {
    /**
     * Init scroll utility for specific anchor links.
     */
    init: function (anchorPrefix = "section-") {
        const anchors = document.querySelectorAll(`a[href*="#${anchorPrefix}"]`);
        anchors.forEach((item) => {
            item.addEventListener("click", (e) => {
                const link = e.currentTarget;
                const target = getTargetFromHashLink(link);
                if (!target)
                    return;
                history.pushState(null, "", getAnchorFromLink(link));
                this.toElement(target);
                e.preventDefault();
            });
        });
    },
    /**
     * Scroll to specific element.
     */
    toElement: function (target) {
        if (!target)
            return;
        const scrollToElementEvent = new Event("to-element.restaumatic.scroll", {
            bubbles: false,
            cancelable: true,
            composed: true,
        });
        document.dispatchEvent(scrollToElementEvent);
        target.style.scrollMarginTop = `${StickyHeader.utils.getStickyHeaderHeight()}px`;
        target.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    },
    /**
     * Scroll to element if target is above our position (it's very likely that user expects it).
     */
    scrollIfAbove: function (target) {
        if (!target)
            return;
        const offsetTop = target.getBoundingClientRect().top;
        const distanceTop = Math.round(offsetTop - StickyHeader.utils.getStickyHeaderHeight());
        if (distanceTop < 0) {
            this.toElement(target);
        }
    },
};
